const API_URL = "https://pwa.netkravler.dk/api";

export default API_URL;
